jQuery.noConflict();

(function ($) {

    $(document).ready(function () {


        //Gform BS
        $('#gform_submit_button_3').on('click', function(e) {
            $('#preloader').show();
        });

        jQuery(document).on('gform_confirmation_loaded', function (event, formId) {

            $('.wave-top').hide();
            $('.fl-button').hide();
            $('#footer-authors').hide();
            $('.eu-logos-wrapper').attr('style', 'display:none !important');
            $('#wrapper-navbar').hide();
            $('body').addClass('prevent-scroll-form');
            $('.mail-hide').css('z-index', 0);

            $('#preloader').hide();
        });

        function closeModal() {
            // javascript:location.reload(true)
        }




        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        $(".gallery-icon a").fancybox();
        $(document).find('*[data-fancybox]').fancybox();

        (function myFormFunction() {
            $(".narocanje-link").on("click", function() {

                $('#input_3_1').val('Zanimamo se za podobno rešitev kot je ' + $(this).attr("data-title") +'. Prosim vas, če bi nam jo lahko predstavili.');
            })

        })();

        
        (function galleryLightbox() {
            $('.lightbox-trigger').click(function(e) {
                e.preventDefault(); 

                var galleryId = $(this).data('gallery-id');
            
                $('[data-fancybox="' + galleryId + '"]').eq(0).trigger('click');

            });

        })();

        (function () {

            let mail = $("#mail-wrapper");

            $(window).scroll(function () {
                var threshold = 500; // number of pixels before bottom of page that you want to start fading
                var op = (($(document).height() - $(window).height()) - $(window).scrollTop()) / threshold;
                if (op <= 0) {
                    $("#mail-wrapper").hide();
                } else {
                    $("#mail-wrapper").show();
                }
                $("#mail-wrapper").css("opacity", op);
            });


            mail.on("click", function () {
                $("#footer").get(0).scrollIntoView({ behavior: 'smooth' });
            })


        })();

        (function () {

            let current_lang = localize.current_lang;
            let div = $('.cookie-notice-container');


            if(current_lang == 'sl'){
                div.prepend("<h4>O PIŠKOTKIH</h4>");
            }else {
                div.prepend("<h4>NOTICE</h4>");
            }
            div.prepend($('<img>', { id: 'cookie-logo', src: 'http://emigma.com/wp-content/themes/emigma/assets/images/ck.png' }));

            if(current_lang == 'sl'){
                div.prepend("<h4 class='cookie-title-sm'>OBVESTILO</h4>");
            }else {
                div.prepend("<h4>COOKIE</h4>");
            }

            

        })();



        //Scroll nav
        (function () {

            $(window).on("scroll", function () {

                //if NOT on top
                if ($(window).scrollTop() != 0) {
                    $(".logo-xl").hide();
                    $("#wrapper-navbar").addClass("top");
                    $(".brand-column").addClass("top");
                    $(".logo-sm").fadeIn("slow");


                } else {
                    $(".logo-sm").hide();
                    $(".brand-column").removeClass("top");
                    $("#wrapper-navbar").removeClass("top");
                    $(".logo-xl").fadeIn("slow");

                }
            });

        })();

        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if (!data) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action': action,
                        'data': data
                    },
                    type: 'POST',
                    success: function (response) {
                        if (response) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }


        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });




        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }


        (function () {

            if (!isMobile) {
                let $frame = $('.frame'),
                    $scrollbar = $('.o-scrollbar');

                if ($frame.length > 0) {
                    dynamicElements.push(
                        {
                            'element': $frame,
                            'property': 'padding-left',
                            'callback': calcFluidPadding
                        }
                    );

                    $frame.css('padding-left', calcFluidPadding());

                    new Sly($frame, {
                        horizontal: 1,
                        itemNav: 'basic',
                        smart: 0,
                        mouseDragging: 1,
                        touchDragging: 1,
                        releaseSwing: 0,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        cycleBy: 'items'
                    }).init();
                }
            }

        })();


        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');

            return ($('body').width() - $container.width()) / 2;
        }


        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.m-wrapper-outer'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[a + 'Width'], height: e[a + 'Height'] };
        }

        $('.entry-content table').each(function () {
            $(this).addClass('table');
        });

        (function () {
            let $table = $('.table');
            if ($table.length > 0) {
                $table.each(function (i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();

        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });

        //Close mobile nav menu on nav item click
        if (isMobile) {
            $('.nav-btn').on('click', function (e) {
                $('#burger-wrapper').trigger('click');
            })
        }

        //language switcher
        (function () {

            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len = this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        } else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

        })();

        //ARROW ANIMACIJA PRI LANG SWITCHERJU
        (function () {
            $('#ar-language-switcher').on('click', function (e) {
                $('#after-target').toggleClass('clicked');
                $('#after-target').toggleClass('clicked-reset');
            })
        })();


        // xx ANIMATIONS

        (function () {

            (function footer_titles_animate() {

                if ($('#footer-titles-animation')[0]) {

                    const footer_titles = $('#footer-titles-animation')[0];

                    function handleIntersection(entries) {
                        entries.map((entry) => {
                            if (entry.isIntersecting) {

                                $('.fade-in').removeClass('invisible');
                                $('.fade-in').addClass('animate__animated');
                                $('.fade-in').addClass('animate__fadeInDown');
                                $('.fade-in').addClass('animate__faster');

                            }

                        });
                    }

                    const observer = new IntersectionObserver(handleIntersection, {
                        threshold: .4
                    });

                    observer.observe(footer_titles);

                }

            })();


            (function footer_header_animate() {


                if ($('#wrapper-header')[0]) {
                    const footer_titles = $('#wrapper-header')[0];

                    function handleIntersection(entries) {
                        entries.map((entry) => {
                            if (entry.isIntersecting) {


                                $('.fade-in-header').removeClass('invisible');
                                $('.fade-in-header').addClass('animate__animated');
                                $('.fade-in-header').addClass('animate__fadeInDown');
                                $('.fade-in-header').addClass('animate__faster');

                            }

                            else {

                                // $('.fade-in-header').removeClass('animate__animated');
                                // $('.fade-in-header').removeClass('animate__fadeInDown');

                            }

                        });
                    }

                    const observer = new IntersectionObserver(handleIntersection, {
                        threshold: 0
                    });

                    observer.observe(footer_titles);
                }
            })();

            (function header_content_animate() {

                if ($('#content-animate')[0]) {

                    const footer_titles = $('#content-animate')[0];

                    function handleIntersection(entries) {
                        entries.map((entry) => {
                            if (entry.isIntersecting) {


                                $('#content-animate, .btn-animate').removeClass('invisible');
                                $('#content-animate, .btn-animate').addClass('animate__animated animate__fadeInDown animate__faster');

                            }

                        });
                    }

                    const observer = new IntersectionObserver(handleIntersection, {
                        threshold: 0
                    });

                    observer.observe(footer_titles);

                }



            })();


            (function footer_widget_animate() {


                if ($('#widget-wrapper-animation')[0]) {
                    const footer_titles = $('#widget-wrapper-animation')[0];

                    function handleIntersection(entries) {
                        entries.map((entry) => {
                            if (entry.isIntersecting) {

                                console.log('intersect widget');

                                $('.fade-in-widget, .gform-column').removeClass('invisible');
                                $('.fade-in-widget').addClass('animate__animated animate__fadeInDown');

                                $('.gform-column').addClass('animate__animated animate__fadeIn');

                            }
                        });
                    }

                    const observer = new IntersectionObserver(handleIntersection, {
                        threshold: 1
                    });

                    observer.observe(footer_titles);
                }
            })();


            (function yellow_squares_animate_sm() {

                var movementStrength = 15;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#yellow-grid-squares").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-y-square-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function yellow_squares_animate_xl() {

                var movementStrength = 80;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#yellow-grid-squares").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1 + 155;
                    $('.animate-y-square-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();

            (function yellow_squares_animate_sm2() {

                var movementStrength = 15;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#yellow-squares-about-us").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-y-square-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function yellow_squares_animate_xl2() {

                var movementStrength = 80;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#yellow-squares-about-us").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1 + 155;
                    $('.animate-y-square-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            (function blue_triangle_animate_sm() {

                var movementStrength = 15;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#narocniki").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-b-tri-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function blue_triangle_animate_xl() {

                var movementStrength = 80;
                var wheight = 2000;
                var height = movementStrength / wheight;
                var width = movementStrength / $(window).width();
                $("#narocniki").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - (wheight / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1 + 155;
                    $('.animate-b-tri-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            if (!isMobile) {
                (function green_circle_animate_sm() {

                    var movementStrength = 15;
                    var height = movementStrength / $(window).height();
                    var width = movementStrength / $(window).width();
                    $("#green-bubble-ekipa, #stories").mousemove(function (e) {
                        var pageX = e.pageX - ($(window).width() / 2);
                        var pageY = e.pageY - ($(window).height() / 2);
                        var newvalueX = width * pageX * -1;
                        var newvalueY = height * pageY * -1;
                        $('.animate-g-circle-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                    });

                })();

                (function green_circle_animate_xl() {

                    var movementStrength = 50;
                    var height = movementStrength / $(window).height();
                    var width = movementStrength / $(window).width();
                    $("#green-bubble-ekipa, #stories").mousemove(function (e) {
                        var pageX = e.pageX - ($(window).width() / 2);
                        var pageY = e.pageY - ($(window).height() / 2);
                        var newvalueX = width * pageX * -1 - 50;
                        var newvalueY = height * pageY * -1 + 220;
                        $('.animate-g-circle-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                    });

                })();
            }

            (function yellow_squares_grid_animate_sm() {

                var movementStrength = 20;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#reference").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-y-square-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function yellow_squares_grid_animate_xl() {

                var movementStrength = 90;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#reference").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 420;
                    $('.animate-y-square-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            (function yellow_circle_animate_sm() {

                var movementStrength = 20;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#storitve-animate").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-y-circle-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function yellow_circle_animate_xl() {

                var movementStrength = 90;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#storitve-animate").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 420;
                    $('.animate-y-circle-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            (function red_square_animate_sm() {

                var movementStrength = 20;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#red-squares-tt, #red-squares-about-us, #stories").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-r-square-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function red_square_animate_xl() {

                var movementStrength = 90;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#red-squares-tt, #stories").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 420;
                    $('.animate-r-square-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();

            (function red_square_animate_xl2() {

                var movementStrength = 90;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#red-squares-about-us").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 20;
                    $('.animate-r-square-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            (function red_tri_animate_sm() {

                var movementStrength = 20;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#ekipa-container").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-r-tri-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function red_tri_animate_xl() {

                var movementStrength = 90;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#ekipa-container").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 420;
                    $('.animate-r-tri-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            (function red_squares_privacy_animate_sm() {

                var movementStrength = 20;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#red-squares-privacy").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-r-privacy-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function red_squares_privacy_animate_xl() {

                var movementStrength = 50;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#red-squares-privacy").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 50;
                    $('.animate-r-privacy-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();


            (function green_360_animate_sm() {

                var movementStrength = 20;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#green-bubble-360").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1;
                    var newvalueY = height * pageY * -1;
                    $('.animate-360-sm').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });


            })();

            (function green_360_animate_xl() {

                var movementStrength = 50;
                var height = movementStrength / $(window).height();
                var width = movementStrength / $(window).width();
                $("#green-bubble-360").mousemove(function (e) {
                    var pageX = e.pageX - ($(window).width() / 2);
                    var pageY = e.pageY - ($(window).height() / 2);
                    var newvalueX = width * pageX * -1 - 50;
                    var newvalueY = height * pageY * -1 + 50;
                    $('.animate-360-xl').css("background-position", newvalueX + "px     " + newvalueY + "px");
                });

            })();

        })();


    });

})(jQuery);